import { queryOptions } from '@tanstack/react-query'
import {
  getMonthlySpend,
  getSixMonthSpend,
  getSixMonthSpendByCurrency,
} from 'src/queries/charts/monthlySpend/monthlySpend.network'

/**
 * The `/charts/*` spend endpoints take no arguments - the backend scopes the
 * response to the authed user's organization - so the keys are static tuples.
 * Keys are colocated here (not in queries.constants.ts) because no
 * cross-feature invalidation or ReactQueryInterop entry references this
 * family today.
 */
export const monthlySpendQueryKeys = {
  all: () => ['charts', 'spend'] as const,
  monthlySpend: () => [...monthlySpendQueryKeys.all(), 'monthly'] as const,
  sixMonthSpend: () => [...monthlySpendQueryKeys.all(), 'sixMonth'] as const,
  sixMonthSpendByCurrency: () =>
    [...monthlySpendQueryKeys.all(), 'sixMonthByCurrency'] as const,
}

export const monthlySpendQueries = {
  monthlySpend: () =>
    queryOptions({
      queryKey: monthlySpendQueryKeys.monthlySpend(),
      queryFn: getMonthlySpend,
    }),
  sixMonthSpend: () =>
    queryOptions({
      queryKey: monthlySpendQueryKeys.sixMonthSpend(),
      queryFn: getSixMonthSpend,
    }),
  sixMonthSpendByCurrency: () =>
    queryOptions({
      queryKey: monthlySpendQueryKeys.sixMonthSpendByCurrency(),
      queryFn: getSixMonthSpendByCurrency,
    }),
}
